// Central catalog of service divisions, categories and site metadata.

export const CONTACT_FALLBACK = {
  address: "1016 Geylang Ave 3, #03-173, Singapore 389731",
  email: "admin@waaanmetal.com",
  phone: "+65 9343 4824",
  whatsapp: "6593434824",
  hdb_license: "",
  business_hours: "Mon–Sat: 9:00am – 6:00pm",
};

export const IMAGES = {
  heroResidential:
    "https://images.unsplash.com/photo-1714860534425-7ce04e013dec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBraXRjaGVuJTIwcmVub3ZhdGlvbiUyMGNhcnBlbnRyeSUyMGNhYmluZXRyeXxlbnwwfHx8fDE3OTE2MzUwODR8MA&ixlib=rb-4.1.0&q=85",
  metalFab:
    "https://images.unsplash.com/photo-1565383690591-1ee1b6582cef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxtZXRhbCUyMGZhYnJpY2F0aW9uJTIwd2VsZGluZyUyMGFyY2hpdGVjdHVyYWwlMjBzdGVlbCUyMGNvbnN0cnVjdGlvbnxlbnwwfHx8fDE3OTE2MzUwMTN8MA&ixlib=rb-4.1.0&q=85",
  heroBg:
    "https://images.unsplash.com/photo-1679430786992-8bb54d023e2f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxtZXRhbCUyMGZhYnJpY2F0aW9uJTIwd2VsZGluZyUyMGFyY2hpdGVjdHVyYWwlMjBzdGVlbCUyMGNvbnN0cnVjdGlvbnxlbnwwfHx8fDE3OTE2MzUwMTN8MA&ixlib=rb-4.1.0&q=85",
  residential1:
    "https://images.unsplash.com/photo-1680416124510-5eae1beca412?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBhcGFydG1lbnQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3OTE2MzUwMjB8MA&ixlib=rb-4.1.0&q=85",
  residential2:
    "https://images.unsplash.com/photo-1738168279272-c08d6dd22002?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBhcGFydG1lbnQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3OTE2MzUwMjB8MA&ixlib=rb-4.1.0&q=85",
  commercial1:
    "https://images.unsplash.com/photo-1497366811353-6870744d04b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3OTE2MzUwMjB8MA&ixlib=rb-4.1.0&q=85",
  commercial2:
    "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvZmZpY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3OTE2MzUwMjB8MA&ixlib=rb-4.1.0&q=85",
  industrial1:
    "https://images.unsplash.com/photo-1772300704502-410f0fbd43bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwd2FyZWhvdXNlJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzkxNjM1MDIwfDA&ixlib=rb-4.1.0&q=85",
  industrial2:
    "https://images.unsplash.com/photo-1694885169342-909981fb408a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHx3YXJlaG91c2UlMjBmYWN0b3J5JTIwaW5kdXN0cmlhbCUyMHN0ZWVsJTIwc3RydWN0dXJlfGVufDB8fHx8MTc5MTYzNTA4NHww&ixlib=rb-4.1.0&q=85",
  gate1:
    "https://images.unsplash.com/photo-1750725013157-5fed2bc90dfc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxzdGFpbmxlc3MlMjBzdGVlbCUyMG1ldGFsJTIwZ2F0ZSUyMGdyaWxsZSUyMGZhYnJpY2F0aW9ufGVufDB8fHx8MTc5MTYzNTA4NHww&ixlib=rb-4.1.0&q=85",
  gate2:
    "https://images.unsplash.com/photo-1608126842524-7e10c3b18453?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxzdGFpbmxlc3MlMjBzdGVlbCUyMG1ldGFsJTIwZ2F0ZSUyMGdyaWxsZSUyMGZhYnJpY2F0aW9ufGVufDB8fHx8MTc5MTYzNTA4NHww&ixlib=rb-4.1.0&q=85",
  interior1:
    "https://images.unsplash.com/photo-1724582586458-a51791349977?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxpbnRlcmlvciUyMGRlc2lnbiUyMDNkJTIwcmVuZGVyJTIwY29uY2VwdCUyMGxpdmluZyUyMHJvb218ZW58MHx8fHwxNzkxNjM1MDg0fDA&ixlib=rb-4.1.0&q=85",
  interior2:
    "https://images.unsplash.com/photo-1705321963943-de94bb3f0dd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxpbnRlcmlvciUyMGRlc2lnbiUyMDNkJTIwcmVuZGVyJTIwY29uY2VwdCUyMGxpdmluZyUyMHJvb218ZW58MHx8fHwxNzkxNjM1MDg0fDA&ixlib=rb-4.1.0&q=85",
  kitchen:
    "https://images.unsplash.com/photo-1631048498692-af6262577031?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBraXRjaGVuJTIwcmVub3ZhdGlvbiUyMGNhcnBlbnRyeSUyMGNhYmluZXRyeXxlbnwwfHx8fDE3OTE2MzUwODR8MA&ixlib=rb-4.1.0&q=85",
};

export const DIVISIONS = [
  {
    slug: "residential-renovation",
    title: "Residential Renovation",
    short: "Residential",
    tagline: "HDB, condo & landed homes — designed, renovated and built.",
    image: IMAGES.residential1,
    projectCategory: "Residential",
    intro:
      "Full-service residential renovation for HDB flats, condominiums and landed properties. From space planning to carpentry, tiling and finishing, we deliver homes that are built to last.",
    services: [
      "HDB BTO Renovation",
      "HDB Resale Renovation",
      "Condominium Renovation",
      "Landed Property Renovation",
      "Kitchen Renovation",
      "Bathroom Renovation",
      "Flooring & Tiling",
      "Carpentry & Cabinetry",
      "Painting & Wall Finishes",
      "False Ceiling & Partition",
      "Doors, Windows & Grilles",
      "Plumbing & Electrical Work Coordination",
    ],
  },
  {
    slug: "commercial-renovation",
    title: "Commercial Renovation",
    short: "Commercial",
    tagline: "Offices, retail, F&B and showrooms fitted out to perform.",
    image: IMAGES.commercial1,
    projectCategory: "Commercial",
    intro:
      "Commercial fit-out and refurbishment that balances brand, function and compliance. We work around your operations to deliver spaces that work for staff and customers.",
    services: [
      "Office Renovation & Fit-Out",
      "Retail Shop Renovation",
      "Restaurant & F&B Renovation",
      "Showroom Renovation",
      "Commercial Interior Design",
      "Glass & Drywall Partitions",
      "Ceiling & Flooring Works",
      "Commercial Refurbishment",
    ],
  },
  {
    slug: "industrial-renovation",
    title: "Industrial Renovation",
    short: "Industrial",
    tagline: "Factories, warehouses and workshops — built for operations.",
    image: IMAGES.industrial1,
    projectCategory: "Industrial",
    regulated: true,
    intro:
      "Industrial renovation and facility works for factories, warehouses and workshops. Structural, electrical, fire-safety and other regulated works are carried out subject to the required approvals and by qualified professionals.",
    services: [
      "Factory Renovation",
      "Warehouse Renovation",
      "Industrial Workshop Setup",
      "Industrial Partition Works",
      "Steel Platforms & Mezzanines",
      "Industrial Metal Fabrication",
      "Facility Maintenance & Refurbishment",
      "Industrial Doors, Gates & Safety Barriers",
    ],
  },
  {
    slug: "metal-works-fabrication",
    title: "Metal Works & Fabrication",
    short: "Metal Works",
    tagline: "Precision stainless, mild steel and aluminium fabrication.",
    image: IMAGES.metalFab,
    projectCategory: "Metal Works",
    intro:
      "Custom metal fabrication for architectural, residential and industrial applications. Stainless steel, mild steel and aluminium — fabricated, finished and installed to specification.",
    services: [
      "Stainless Steel Fabrication",
      "Mild Steel Fabrication",
      "Aluminium Works",
      "Metal Gates & Grilles",
      "Staircases & Handrails",
      "Steel Platforms",
      "Custom Metal Components",
      "Welding & Metal Repairs",
      "Architectural Metal Works",
    ],
  },
];

export const INTERIOR_SERVICES = [
  "Residential Interior Design",
  "Commercial Interior Design",
  "Space Planning",
  "Concept Design",
  "3D Visualisation",
  "Material & Finish Selection",
  "Design & Build Project Coordination",
];

export const PROJECT_CATEGORIES = ["All", "Residential", "Commercial", "Industrial", "Metal Works", "Interior Design"];

export const PROCESS_STEPS = [
  { title: "Enquiry", desc: "Share your project details and reference files through our quotation form." },
  { title: "Consultation", desc: "We discuss requirements and arrange a site assessment." },
  { title: "Quotation", desc: "A detailed, transparent quotation tailored to your scope." },
  { title: "Planning", desc: "Design, scheduling and approvals are confirmed before works begin." },
  { title: "Execution", desc: "Skilled teams carry out works to agreed standards and timeline." },
  { title: "Handover", desc: "Final inspection, clean-up and handover of your completed space." },
];

export const WHY_CHOOSE = [
  { title: "HDB-Registered Contractor", desc: "Operating as an HDB-registered renovation contractor for permitted residential works." },
  { title: "Multi-Disciplinary Team", desc: "Renovation, fit-out, interior design and in-house metal fabrication under one roof." },
  { title: "Transparent Quotations", desc: "Clear, itemised quotations with no hidden charges." },
  { title: "Industrial-Grade Expertise", desc: "From homes to factories — engineering discipline on every project." },
  { title: "Design Capability", desc: "Space planning and 3D visualisation that bring your concept to life." },
  { title: "Compliance-Focused", desc: "Regulated works carried out subject to the required approvals and qualified professionals." },
];

export const FEATURED_PRICE_LISTS = [
  { cat: "Hacking & Dismantling", icon: "Hammer", teaser: "from $60", blurb: "Whole-house, toilet, wall & item dismantling." },
  { cat: "Tiling", icon: "Grid3x3", teaser: "from $6.00 psf", blurb: "Floor, wall, screed & skirting labour." },
  { cat: "Carpentry", icon: "Ruler", teaser: "from $27 psf", blurb: "Wardrobes, kitchen cabinets, feature walls." },
  { cat: "Plumbing", icon: "Droplets", teaser: "from $70", blurb: "PUB-licensed toilet & kitchen plumbing." },
  { cat: "Electrical", icon: "Zap", teaser: "from $15", blurb: "Lighting, power points & relocations." },
  { cat: "Ceiling & Partition", icon: "Layers", teaser: "from $3.75 pfr", blurb: "False ceiling, cornices & partitions." },
  { cat: "Bathroom Renovation", icon: "Bath", teaser: "from $9,500", blurb: "2-bathroom overlay or hack-and-tile." },
  { cat: "Renovation Coordination", icon: "ClipboardList", teaser: "from $1,000", blurb: "Fixed-fee project coordination." },
];

export const GUIDES = [
  { title: "How renovation pricing works in Singapore", excerpt: "Understand labour, material and tile cost breakdowns so you can compare quotes like a pro — no hidden markups.", tag: "Pricing", cat: "Tiling" },
  { title: "HDB resale hacking: what's included", excerpt: "A plain-English look at whole-house hacking scope, disposal and the add-ons that catch homeowners out.", tag: "Hacking", cat: "Hacking & Dismantling" },
  { title: "Planning your bathroom renovation", excerpt: "Overlay or hack-and-tile? We break down the two approaches, timelines and what each package covers.", tag: "Bathroom", cat: "Bathroom Renovation" },
];

export const divisionBySlug = (slug) => DIVISIONS.find((d) => d.slug === slug);
export const serviceSlug = (name) => name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
export const findService = (slug) => {
  for (const d of DIVISIONS) {
    const s = d.services.find((x) => serviceSlug(x) === slug);
    if (s) return { service: s, division: d };
  }
  return null;
};
